module.exports = __webpack_public_path__ + "static/img/recommend03.7eb77cc1.png";